var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellSlash = function SvgBellSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.019 6.523A6.085 6.085 0 0 0 4 7v1.931c0 .372-.104.736-.301 1.051l-2.022 3.235A1.166 1.166 0 0 0 2.666 15h9.265L4.019 6.523ZM17.4 14.998a1.166 1.166 0 0 0 .922-1.781L16.3 9.982A1.982 1.982 0 0 1 16 8.932V7A6 6 0 0 0 5.872 2.646L17.4 14.998ZM2.318 1.77a1 1 0 0 1 1.413.049l14 15a1 1 0 0 1-1.462 1.364l-14-15a1 1 0 0 1 .049-1.413ZM10 19a3 3 0 0 1-2.958-2.5h5.917A3 3 0 0 1 10 19Z"
  })));
};
export default SvgBellSlash;